"use client";
import React, { useEffect } from "react";
import styled from "styled-components";
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import InnerBanner from "@/components/InnerBanner";
import MediaFilter from "@/components/media/MediaFilter";
import useSplitTextAnimation from "@/components/hooks/useSplitTextAnimation";

// gsap.registerPlugin(SplitText);

const AllUcbHub = ({ data, getDownloadData, getExpertData }) => {
  const banner = data?.[0]?.banner;

  // split text
  // useSplitTextAnimation(".split-up", [data]);

  return (
    <StyledComponent>
      <InnerBanner
        img={banner?.img}
        subtitle={banner?.subtitle}
        title={banner?.title}
        text={banner?.desc}
      />
      <MediaFilter
        mediaList={data?.[0]}
        downloadHub={getDownloadData?.[0]}
        expertList={getExpertData}
      />
    </StyledComponent>
  );
};

const StyledComponent = styled.section``;

export default AllUcbHub;
